import anychart from 'anychart'

const anyChartLicenseKey = 'growens.io-72b05fe4-d0680dda'

anychart.licenseKey(anyChartLicenseKey)
anychart.theme({ chart: { credits: { enabled: false } } })

export default anychart
